module.exports = __webpack_public_path__ + "static/media/always_nearby.f7ff5740.svg";